import { h } from 'preact';
import { useState } from 'preact/hooks';
import clsx from 'clsx';
import SubMenuContainer from './submenu-container';
import voyagesTitle from '../utils/voyages-title';


const MenuItem = ({ link, setShowBackDrop, setHeaderVoyagesLayout }) => {
  const [subMenuShowed, setSubMenuShowed] = useState(false);

  const showShopAll = link.url !== '#' ? link : false;
  const isVoyagesLayout = link?.title?.includes('#voyages');

  return (
    <li
      key={`${link.title}-${link.url}`}
      className={clsx(
          'flex items-center h-full border-b-[1.5px] border-transparent hover:border-black min-h-[74px]',
        link.title === 'Holiday Boutique' ? 'text-red' : '',
      )}
      onMouseEnter={() => {
        setSubMenuShowed(true);
        setShowBackDrop(true);
        setHeaderVoyagesLayout(isVoyagesLayout);
      }}
      onMouseLeave={() => {
        setSubMenuShowed(false);
        setShowBackDrop(false);
        setHeaderVoyagesLayout(false);
      }}
    >
      <a
        href={link.url}
        className={
          'utility-1 leading-[1] font-medium tracking-[0.02em] uppercase link-unstyled'
        }
      >
        {isVoyagesLayout ? voyagesTitle(link.title) : link.title}
      </a>
      {link?.submenus?.length > 0 && (
        <SubMenuContainer
          menu={link.submenus}
          subMenuShowed={subMenuShowed}
          showShopAll={showShopAll}
          shopAllTitle={isVoyagesLayout ? "voyages" : link.title}
          isVoyagesLayout={isVoyagesLayout}
        />
      )}
    </li>
  );
};

export default MenuItem;
